<template>
  <div class="card mb-2">
    <div class="card-header bg-primary text-white d-flex">
      <a v-b-toggle="`collapse-associated-services-card`" class="collapse-icon c-pointer">
        <font-awesome-icon class="when-opened" icon='caret-down' size="lg" />
        <font-awesome-icon class="when-closed fa-w-10" icon='caret-right' size="lg" />
      </a>
      <span class="font-weight-bold">Associated Services</span>
    </div>
    <b-collapse
      v-model="showCollapse"
      :id="`collapse-associated-services-card`"
    >
      <div class="card-body">
      <LoadingSpinner v-if="loading" message ='Loading Associated Services' size = '1x'>
      </LoadingSpinner>
        <template v-if="!loading">
          <div v-if="!entities || entities.length === 0">
            No Services have been associated to this Property
          </div>
          <div v-for='entity in visibleEntities'
            :key='entity.id'
            class="card listing-card">
            <div class="card-body row">
              <div class="col-md-2">
                <div class="list-header">
                  Service ID
                </div>
                <div class="list-details">
                 {{entity.id || 'None'}} {{ entity.isMultiProperty ? ' (MP)' : '' }}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Service Category
                </div>
                <div class="list-details">
                  {{ getCategoryName(entity.categoryId) }}
                </div>
              </div>
              <div class="col-md-3">
                <div class="list-header">
                  Service Component(s)
                </div>
                <div class="list-details" v-if="!agreementTypesLoading">
                  {{ componentsString(entity) }}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Open Date
                </div>
                <div class="list-details">
                  {{ entity.openDate || entity.createdAt | dateString }}
                </div>
              </div>
              <div class="col-md-2">
                <div class="list-header">
                  Service Status
                </div>
                <div class="list-details">
                  {{ getStatusName(entity.statusId) || 'None'}}
                </div>
              </div>
              <div class = "col-md-1 d-flex justify-content-end align-self-center">
                <router-link
                :to="{ name: 'projectService', params: {
                  project_id: $route.params.project_id,
                  id: entity.id }}"
                  class="btn btn-secondary btn-sm" tag="button">
                  View
                </router-link>
              </div>
            </div>
          </div>
          <PaginationControls
           :orderedEntities="orderedEntities"
           :initialPageSize="initialPageSize"
           :pageSize="pageSize"
           :pageSizeOptions="pageSizeOptions"
           :currentPage="currentPage"
           :firstVisibleEntry="firstVisibleEntry"
           :lastVisibleEntry="lastVisibleEntry"
           :rows="rows"
           @update-current-page="updateCurrentPage"
           @update-page-size="updatePageSize">
          </PaginationControls>
        </template>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CollapseControl from '@/mixins/CollapseControl';
import { EntityModules, LookupModules } from '@/store/moduleConfig';
import LoadingSpinner from './LoadingSpinner.vue';
import Pagination from '@/mixins/Pagination';
import PaginationControls from './common/PaginationControls.vue';

export default {
  name: 'AssociatedServicesCard',
  components: {
    LoadingSpinner,
    PaginationControls,
  },
  mixins: [CollapseControl, Pagination],
  data() {
    return {
      showCollapse: false,
    };
  },
  created() {
    this.$store.dispatch(`${LookupModules.SERVICE_TYPES.namespace}/fetchOptions`,
      LookupModules.SERVICE_TYPES.url);
    this.$store.dispatch(`${LookupModules.SERVICE_STATUSES.namespace}/fetchOptions`,
      LookupModules.SERVICE_STATUSES.url);
  },
  computed: {
    ...mapState(EntityModules.ASSOCIATED_SERVICES.namespace, {
      entities: state => state.entities,
      loading: state => state.loading,
    }),
    ...mapState(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.SERVICE_STATUSES.namespace, {
      getStatusName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_TYPES.namespace, {
      getTypeName: 'getName',
    }),
    ...mapGetters(LookupModules.SERVICE_CATEGORIES.namespace, {
      getCategoryName: 'getName',
    }),
  },
  methods: {
    // eslint-disable-next-line
    entitySort(a, b) {
      // this looks kind of hacky, but we are just preserving the order from the
      // server because it had complicated rules for sorting against the status and events
      return this.entities.indexOf(a) - this.entities.indexOf(b);
    },
    componentsString(entity) {
      if (entity && entity.typeIds) {
        const typeIdsCopy = [...entity.typeIds];
        return typeIdsCopy
          .sort()
          .map(pi => this.getTypeName(pi))
          .join('; ');
      }
      return null;
    },
  },
};
</script>
